import { useTranslate } from "@tolgee/react";
import React from "react";
import { Message, Segment } from "semantic-ui-react";

const NotFound = () => {
  const { t } = useTranslate();

  return (
    <Segment size="big" style={{ height: "100%" }}>
      <Message
        header={t({
          key: "pages.notFound.header",
          defaultValue: "404 - Page Not Found!",
        })}
        content={t({
          key: "pages.notFound.content",
          defaultValue:
            "We are sorry but the page you are looking for does not exist.",
        })}
      />
    </Segment>
  );
};

export default NotFound;
